import type { AskPageVars, AskPageViewerStatus } from "./pageVars";

export type AskPageMode = "free" | "paid" | "member";

export const viewerIsOwner = (status: AskPageViewerStatus): boolean =>
	status === "owner";

export const viewerIsSubscribed = (status: AskPageViewerStatus): boolean =>
	status === "free_subscriber" || status === "pass" || status === "member";

export const viewerCanAsk = (
	paidPage: boolean,
	status: AskPageViewerStatus,
): boolean =>
	!paidPage || status === "owner" || status === "pass" || status === "member";

export const myAskPageUrl = (tab: "page" | "questions" | "access"): string =>
	`/studio/my-ask-page?tab=${tab}`;

export const boardIconSymbol = (icon: string | null | undefined): string => {
	if (typeof icon !== "string") {
		return "space_dashboard";
	}
	const name = icon.trim();
	if (name === "" || name === "undefined" || name === "null") {
		return "space_dashboard";
	}
	return name;
};

export const askPageMode = (vars: AskPageVars): AskPageMode => {
	if (!vars.is_paid_ask_page) {
		return "free";
	}
	return vars.status === "member" || vars.status === "pass" ? "member" : "paid";
};

export const formatCount = (value: number | null | undefined): string => {
	if (value == null) {
		return "—";
	}
	return new Intl.NumberFormat(undefined, {
		notation: "compact",
		maximumFractionDigits: 1,
	}).format(value);
};

export const formatMoney = (amountMinor: number, currency: string): string => {
	try {
		return new Intl.NumberFormat(undefined, {
			style: "currency",
			currency,
			// en-GB (and similar) otherwise print USD as "US$".
			currencyDisplay: "narrowSymbol",
			minimumFractionDigits: amountMinor % 100 === 0 ? 0 : 2,
			maximumFractionDigits: 2,
		}).format(amountMinor / 100);
	} catch {
		return `${(amountMinor / 100).toFixed(2)} ${currency}`;
	}
};

export const formatCountry = (
	code: string | null | undefined,
): string | null => {
	if (!code) {
		return null;
	}
	try {
		return (
			new Intl.DisplayNames(undefined, { type: "region" }).of(
				code.toUpperCase(),
			) ?? code
		);
	} catch {
		return code;
	}
};

export const addCardUrl = (handle: string): string => {
	const params = new URLSearchParams({ return: "ask-page", handle });
	return `/account/payment-methods?${params.toString()}`;
};
